<template>
    <div>
        <import-excel ref="excel-data" :label="label" @fileIsReady="fileIsReady"/>
    </div>
</template>

<script>
    import Xlsx from "./xlsx";
    import ImportExcel from "../../components/ excel/import-excel/ImportExcel";

    export default {
        name: "XlsxController",
        components: {
            ImportExcel
        },
        props: {
            label: {
                type: String,
                default: 'File input'
            }
        },
        data(){
            return {
                xlsx : null,
                workbook : null,
                firstWorkSheet: null,
            }
        },
        methods: {
            fileIsReady(v){
                this.$emit('fileIsReady', v);
            },

            async create(start){
                const wb = await this.makeWB();
                if(wb){
                    this.makeFirstWS(start);
                }
            },


            async makeWB(){
                const file = this.$refs['excel-data'].file;
                const validate = this.$refs['excel-data'].$refs['v-file'].valid;

                if(validate){
                    this.workbook = await this.xlsx.getWorkBook(file);
                    return this.workbook;
                } else {
                    this.$alert('잘못된 파일 입니다.');
                    return null
                }
            },

            getWB(){
                if(this.workbook){
                    return this.workbook;
                } else {
                    this.$alert('workbook이 없습니다.')
                    return null
                }
            },

            makeFirstWS(start){
                if(this.workbook){
                    const ws = this.workbook.Sheets[this.workbook.SheetNames[0]];
                    this.firstWorkSheet = this.xlsx.sheetToJson(ws,start);
                    return this.firstWorkSheet;
                } else {
                    this.$alert('workbook이 없습니다.')
                    return null
                }
            },

            getWS(sheetNumber, start){
                if(this.workbook){
                    const ws = this.workbook.Sheets[this.workbook.SheetNames[sheetNumber]];
                    return this.xlsx.sheetToJson(ws,start);
                } else {
                    this.$alert('workbook이 없습니다.')
                    return null
                }
            },

            getFirstSheetWS(){
                if(this.firstWorkSheet){
                    return this.firstWorkSheet;
                } else {
                    this.$alert('worksheet가 없습니다.')
                    return null
                }
            },

            getHeaderArr(sheetNumber, range){
                if(this.workbook){
                    const ws = this.workbook.Sheets[this.workbook.SheetNames[sheetNumber]];
                    return this.xlsx.withinTheRangeSheetToJson(ws,range);
                } else {
                    this.$alert('workbook이 없습니다.')
                    return null
                }
            },

            writeFile(wb, fileName){
                this.xlsx.writeFile(wb, fileName);
            },

            newWorkbookWithDataChange(targetSheetNumber, data, start){
                const wb = this.xlsx.setNewWorkbook();
                const ws = this.xlsx.aoaToSheet(data, start)

                if(this.workbook.SheetNames.length > 1){
                    this.workbook.SheetNames.map((name, idx)=> {
                        if(idx !== targetSheetNumber){
                            this.xlsx.appendSheet(wb, this.workbook.Sheets[this.workbook.SheetNames[idx]], this.workbook.SheetNames[idx]);
                        } else {
                            this.xlsx.appendSheet(wb, ws, this.workbook.SheetNames[targetSheetNumber]);
                        }
                    })
                } else {
                    this.xlsx.appendSheet(wb, ws, this.workbook.SheetNames[targetSheetNumber]);
                }

               return wb;
            }

        },

        mounted() {
            this.xlsx = new Xlsx();
        }
    }
</script>

<style scoped>

</style>